import React from 'react';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import {
  Banner,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AlertIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';

import messages from './messages';

const AddContractConfirmationModal = ({ open, onClose, onConfirm, intl }) => {
  // Same action shape as DeleteContractModal: Modal reads `variant ?? children === 'Cancel'`, so an
  // explicit variant turns both buttons into text ones. Leave it off.
  const actionsProps = [
    {
      children: intl.formatMessage(messages.cancel),
      onClick: onClose,
    },
    {
      children: intl.formatMessage(messages.confirm),
      onClick: onConfirm,
      submitButton: true,
    },
  ];

  return (
    <Modal
      open={open}
      title={intl.formatMessage(messages.title)}
      onClose={onClose}
      icon={<AlertIcon />}
      status={'warning'}
      actionsProps={actionsProps}
    >
      <Typography
        variant={'bodyMedium'}
        color={'text.secondary'}
        marginBottom={1.5}
        display={'block'}
      >
        {intl.formatMessage(messages.confirmationText)}
      </Typography>
      <Banner
        status={'warning'}
        message={intl.formatMessage(messages.warningBanner)}
      />
    </Modal>
  );
};

export default AddContractConfirmationModal;
